// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"aq-z","breadcrumbForward":"bq-z","breadcrumbBack":"cq-z","selected":"dq-z"};